module.exports = __webpack_public_path__ + "img/7_153.a2818bfd.png";